import { render, staticRenderFns } from "./expose.vue?vue&type=template&id=0fb72c06"
import script from "./expose.vue?vue&type=script&lang=js"
export * from "./expose.vue?vue&type=script&lang=js"
import style0 from "./expose.vue?vue&type=style&index=0&id=0fb72c06&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports